(function bikeRiseAgree() {
  function updateButton() {
    const checkoutButton = document.querySelector('[name="checkout"], #checkout-button');
    const agreeCheckbox = document.getElementById("agree-checkbox");
    const confirmCheckbox = document.getElementById("confirm-buy-now-checkbox");

    if (!checkoutButton) return;

    // Tarkistetaan onko jompikumpi ruutu valittuna
    const isChecked = (agreeCheckbox?.checked || confirmCheckbox?.checked || false);

    checkoutButton.disabled = !isChecked;
    checkoutButton.style.opacity = isChecked ? "1" : "0.5";
    checkoutButton.style.cursor = isChecked ? "pointer" : "not-allowed";
  }

  // 1. EVENT DELEGATION: Kuunnellaan kaikkia "change"-tapahtumia sivustolla
  document.addEventListener("change", function(event) {
    if (event.target.id === "agree-checkbox" || event.target.id === "confirm-buy-now-checkbox") {
      updateButton();
    }
  });

  // 2. TARKISTUS MUUTOKSISSA: Horizon-teeman AJAX-ostoskoria varten
  const observer = new MutationObserver(() => {
    updateButton();
  });

  document.addEventListener("DOMContentLoaded", function() {
    updateButton();
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // 3. VARMUUDEN VUOKSI: Tarkistus, kun hiiri liikkuu kassanapin päälle
  // (Tämä herättää napin, jos mikään muu ei toiminut)
  document.addEventListener("mouseover", function(event) {
    if (event.target.name === "checkout" || event.target.id === "checkout-button") {
      updateButton();
    }
  });
})();